// extracted by mini-css-extract-plugin
module.exports = {"credit":"credit--R8AkV","is-embed":"is-embed--sFyQS","isEmbed":"is-embed--sFyQS","icon":"icon--b5rn2","name":"name--ynQZ6"};